import StubAssetsAuditTable from "../MusicAssetAuditComponents/StubAssetsAudits";

const StubAssetsRoute = () => {
  return <StubAssetsAuditTable />;
};

export default StubAssetsRoute;
